import { BillingType, CountryCodes } from '@/generated/graphql';

export const FEATURE_SIGNUP_RIGHT_OF_WITHDRAW_CHECKBOX_COUNTRIES = [
  CountryCodes.De,
];

export const APP_NAME = 'CHECKOUTUINODEWEB_ONBOARDING_LITE';

// Countries where BOLT (Block Off Domestic -Local- Transactions) apply
export const BOLT_COUNTRIES = [CountryCodes.Kr, CountryCodes.Tw];

// Waiting for legal to approve these two countries for the new BFX experience
export const DCC_INELIGIBLE_COUNTRIES = [CountryCodes.Hu, CountryCodes.Il];

// Every country PayPal supports has English enabled, so we fallback to that
export const DEFAULT_ENABLED_LANGUAGES = ['en'];

// These countries are part of GROUP-EMEA but have different legal content
export const EMEA_LITE_COUNTRIES = [
  CountryCodes.Bg,
  CountryCodes.Cy,
  CountryCodes.Gf,
  CountryCodes.Gi,
  CountryCodes.Hr,
  CountryCodes.Li,
  CountryCodes.Mq,
  CountryCodes.Re,
  CountryCodes.Sm,
  CountryCodes.Va,
  CountryCodes.Yt,
];

export const EMEA_PASSWORDLESS_WITHOUT_COOKIES = [
  CountryCodes.Ch,
  CountryCodes.Eg,
  CountryCodes.Sa,
  CountryCodes.Ua,
  CountryCodes.Za,
];

export const FRAUD_NET_FIELD_LIST = [
  // FI fields
  { id: 'cardCvv', min: 3 },
  { id: 'cardExpiry', min: 7 },
  { id: 'cardNumber', min: 8 },

  // Contact information
  { id: 'email', min: 13 },
  { id: 'firstName', min: 5 },
  { id: 'lastName', min: 5 },
  { id: 'phone', min: 10 },

  // Address fields
  { id: 'city', min: 5 },
  { id: 'line1', min: 5 },
  { id: 'line2', min: 2 },
  { id: 'postalCode', min: 5 },
  { id: 'state', min: 2 },

  // Signup fields
  { id: 'dob', min: 8 },
  { id: 'password', min: 8 },
];

export const GEO_REGIONS = ['APAC', 'EMEA', 'LATAM'];

export const KYC_DOB_NATIONALITY = ['DateOfBirth', 'Nationality'];

export const KYC_DOB_NATIONALITY_ID = [
  'DateOfBirth',
  'Nationality',
  'IdentityDocumentType',
  'IdentityDocumentNumber',
];

export const MULTI_PRODUCT_SUPPORTED = [CountryCodes.Us];

export const LOG_PREFIX = /^weasley_/i;

export const X_APP_NAME = 'checkoutuinodeweb_weasley';

export const CHECKOUT_SESSION_TYPES = {
  BILLING_WITH_PURCHASE: 'BILLING_WITH_PURCHASE',
  BILLING_WITHOUT_PURCHASE: 'BILLING_WITHOUT_PURCHASE',
};

// EC Sub has three variants
// https://engineering.paypalcorp.com/confluence/display/Checkout/Subscription+Migration
export const EC_SUBSCRIPTION_VARIANTS: string[] = [
  BillingType.RecurringPayments,
  BillingType.RecurringPaymentsV1,
  BillingType.SubscriptionsV1,
];

export const USER_ACTIONS = {
  commit: 'COMMIT',
  continue: 'CONTINUE',
};

export const REGULATION_E_COUNTRIES = [CountryCodes.Us];

export const SEPA_MANDATE_COUNTRIES = [CountryCodes.De];

export const SELECT_ALL_SIGNUP_TERMS_COUNTRIES = [CountryCodes.Kr];
